import type { FunctionComponent } from "react";
import React from "react";
import { OptionsMenuItem } from "../../components/OptionsMenuItem";
import { SmallActionButton } from "screens/content/contentCanvas/cell/SmallActionButton";
import { RiShareForwardLine, RiDeleteBinLine } from "react-icons/ri";
import { useButtonProps } from "hooks";
import { Button } from "@chakra-ui/react";

interface Props {
  isDisabled?: boolean;
  isIcon?: boolean;
  isMenuItem?: boolean;
  size?: string;
  onClickMove: () => void;
  onClickRemove?: () => void;
}

export const ProjectMoveButton: FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<Props>>> = ({
  isDisabled = false,
  isIcon = false,
  isMenuItem = false,
  size = "1rem",
  onClickMove,
  onClickRemove,
}) => {
  const deleteButtonProps = useButtonProps("sm", "delete");

  return (
    <>
      {isMenuItem ? (
        <>
          <OptionsMenuItem
            menuLabel="Move Portfolio"
            className={"ch-move-project"}
            onClick={() => {
              onClickMove();
            }}
            isDisabled={isDisabled}
          />
          {onClickRemove && (
            <OptionsMenuItem
              menuLabel="Remove from Portfolio"
              className={"ch-remove-project"}
              onClick={() => {
                onClickRemove();
              }}
              isDisabled={isDisabled}
            />
          )}
        </>
      ) : !isIcon ? (
        <>
          <Button
            className={"ch-move-project"}
            aria-label={`Move Project`}
            {...deleteButtonProps}
            onClick={(event) => {
              event.stopPropagation();
              onClickMove();
            }}>
            Move Portfolio
          </Button>
          {onClickRemove && (
            <Button
              className={"ch-remove-project"}
              aria-label={`Remove Project`}
              {...deleteButtonProps}
              onClick={(event) => {
                event.stopPropagation();
                onClickRemove();
              }}>
              Remove from Portfolio
            </Button>
          )}
        </>
      ) : (
        <>
          <SmallActionButton
            isDisabled={isDisabled}
            classNames={"ch-move-project"}
            iconTypeName={RiShareForwardLine}
            tooltip={`Move Project`}
            iconSize={size}
            onClick={() => {
              onClickMove();
            }}
          />
          {onClickRemove && (
            <SmallActionButton
              isDisabled={isDisabled}
              classNames={"ch-remove-project"}
              iconTypeName={RiDeleteBinLine}
              tooltip={`Remove Project`}
              iconSize={size}
              onClick={() => {
                onClickRemove();
              }}
            />
          )}
        </>
      )}
    </>
  );
};
